// import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import './ui/i18n/config';
import { ToastProvider, BreakpointProvider, LoadingProvider } from './ui/components';
import AppRoutes from './routes';
// import { isTokenValid, validateToken, doLogout } from './ui/utils/auth';
import './ui/styles/theme.scss';

const App = () => {
  return (
    <BrowserRouter basename="/">
      <ToastProvider>
        <LoadingProvider>
          <BreakpointProvider>
            <AppRoutes />
          </BreakpointProvider>
        </LoadingProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;
